import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

import { MxEmitEvent, MxEventBusService, MxEvents } from '../../services';

@Injectable()
export class MxOverlayRequestResponseInterceptor implements HttpInterceptor {
  constructor(private eventBus: MxEventBusService) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    this.eventBus.emit(new MxEmitEvent(MxEvents.HttpRequest));
    return next.handle(req).pipe(
      tap((event) => {
        if (event instanceof HttpResponse) {
          this.eventBus.emit(new MxEmitEvent(MxEvents.HttpResponse));
        }
      }),
      catchError((error: HttpErrorResponse) => {
        this.eventBus.emit(new MxEmitEvent(MxEvents.HttpResponse));
        return throwError(error);
      })
    );
  }
}
